import React, { useState } from 'react';
import { Calendar as CalendarIcon } from 'lucide-react';
import { Button } from './ui/button';
import { Calendar } from './ui/calendar';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';
import { cn } from '@/lib/utils';
import { format } from 'date-fns';

/**
 * DatePicker — auto-closes on date selection. Works inside Dialogs.
 */
const DatePicker = ({ value, onChange, placeholder = 'Pick a date', disabled = false, className, maxDate, minDate, ...rest }) => {
  const [open, setOpen] = useState(false);

  const dateValue = value ? new Date(value + 'T00:00:00') : undefined;

  const handleSelect = (date) => {
    if (date) {
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const dd = String(date.getDate()).padStart(2, '0');
      onChange(`${yyyy}-${mm}-${dd}`);
    } else {
      onChange('');
    }
    setOpen(false);
  };

  const disabledDays = [];
  if (maxDate) disabledDays.push({ after: maxDate });
  if (minDate) disabledDays.push({ before: minDate });

  return (
    <Popover open={open} onOpenChange={setOpen} modal={true}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          disabled={disabled}
          className={cn(
            'w-full justify-start text-left font-normal h-11',
            !value && 'text-muted-foreground',
            className
          )}
          data-testid={rest['data-testid']}
          onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpen(true); }}
        >
          <CalendarIcon className="mr-2 h-4 w-4 shrink-0" />
          {dateValue ? format(dateValue, 'PPP') : <span>{placeholder}</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 z-[9999]" align="start" onOpenAutoFocus={(e) => e.preventDefault()}>
        <Calendar
          mode="single"
          selected={dateValue}
          onSelect={handleSelect}
          disabled={disabledDays.length > 0 ? disabledDays : undefined}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
};

export default DatePicker;
